import React, { createContext, useContext, useRef } from 'react';

const ValidationDataContext = createContext(null);

export function ValidationDataProvider({ children }) {
  const cacheRef = useRef(new Map());

  const get = (client, date) => cacheRef.current.get(`${client}_${date}`) ?? null;
  const set = (client, date, data) => cacheRef.current.set(`${client}_${date}`, data);

  return (
    <ValidationDataContext.Provider value={{ get, set }}>
      {children}
    </ValidationDataContext.Provider>
  );
}

export const useValidationData = () => useContext(ValidationDataContext);
